const CID_PATTERN = /\(cid:\d+\)|cid:\d+|CID[:\s]+\d+/gi;
const GARBAGE_PATTERN = /(?:\uFFFD|Ã|Â|â€|â€™|â€œ|â€\x9d)/g;

export function normalizeDisplayLanguage(language) {
  const raw = String(language || '').trim().toLowerCase();
  if (!raw) return 'en';
  if (raw === 'english') return 'en';
  if (raw === 'hindi') return 'hi';
  return raw.split('-', 1)[0] || 'en';
}

export function looksGarbled(text) {
  const sample = String(text || '').slice(0, 1800);
  if (!sample.trim()) return false;
  const compact = sample.replace(/\s+/g, '');
  const cidHits = (sample.match(CID_PATTERN) || []).length;
  const garbageHits = (sample.match(GARBAGE_PATTERN) || []).length;
  const alphaNumRatio = Array.from(compact).filter((char) => /[A-Za-z0-9\u0900-\u0D7F]/.test(char)).length / Math.max(compact.length, 1);
  return cidHits >= 2 || garbageHits >= 3 || (compact.length > 80 && alphaNumRatio < 0.35);
}

export function cleanSourceText(text, maxChars = 520) {
  const raw = String(text || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n').trim();
  if (!raw) return '';
  const cleaned = raw
    .split('\n')
    .map((line) => line.trim())
    .filter((line, index, lines) => {
      if (!line) return index === 0 ? false : lines[index - 1] !== '';
      if (/\(cid:\d+\)|cid:\d+|CID[:\s]+\d+/i.test(line)) return false;
      return true;
    })
    .join('\n')
    .replace(GARBAGE_PATTERN, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
  return cleaned.slice(0, maxChars);
}

export function chooseVisibleSourceText(source, displayLanguage = 'en') {
  const preferred = normalizeDisplayLanguage(displayLanguage);
  const englishText = cleanSourceText(source?.englishText || source?.displayText || '');
  const originalText = cleanSourceText(source?.rawText || source?.snippet || source?.quote || '');
  const summary = cleanSourceText(source?.summary || '');

  if (preferred === 'en') {
    if (englishText && !looksGarbled(englishText)) {
      return { text: englishText, language: 'en', usedEnglish: true };
    }
    if (summary) {
      return { text: summary, language: 'en', usedEnglish: false };
    }
  }

  if (originalText && !looksGarbled(originalText)) {
    return { text: originalText, language: preferred, usedEnglish: false };
  }
  if (englishText) {
    return { text: englishText, language: 'en', usedEnglish: true };
  }
  return { text: summary, language: 'en', usedEnglish: false };
}

export function buildSourceLanguageLabel(source, displayLanguage = 'en') {
  const visible = chooseVisibleSourceText(source, displayLanguage);
  if (!visible.text) return '';
  if (visible.usedEnglish) return 'English default';
  return 'Original language';
}
